import { graphql } from "@/lib/gql/__generated__";

export const BasicCustomMailSetting = graphql(/* GraphQL */ `
	query BasicCustomMailSetting($hotelID: ID!) {
		hotel(hotelID: $hotelID) {
			id
			hotelID
			companyID
			email
		}
		basicCustomMailSetting(hotelID: $hotelID) {
			id
			forReservation {
				atCreated {
					text
				}
				atUpdated {
					text
				}
				atCanceled {
					text
				}
				atCheckInBefore_07days {
					text
					shouldSendEmail
				}
				atCheckInBefore_01days {
					text
					shouldSendEmail
				}
				atCheckInBefore_00days {
					text
					shouldSendEmail
				}
				atCheckOutAfter_01days {
					text
					shouldSendEmail
				}
				atRequest {
					text
				}
				atConfirmed {
					text
				}
				atDeclined {
					text
				}
			}
			forShopping {
				atCreated {
					text
				}
			}
			mailFooterExternalLink
		}
	}
`);
